import Vue from "vue";
import store from "../store";
import { showAlert, showConfirm, Swal } from "../utils/swal";

Vue.prototype.$swal = Swal;
Vue.prototype.$alert = showAlert;
Vue.prototype.$confirm = showConfirm;

// Semua snackbar (commit atau mutate langsung) → SweetAlert toast
store.watch(
  (state) => state.snackbar.state,
  (open) => {
    if (!open) return;
    const { text, color } = store.state.snackbar;
    store.commit("SNACKBAR_MUTATION", { state: false });
    showAlert(text, color);
  }
);

export { showAlert, showConfirm, Swal };
export default Swal;
